module.exports = __webpack_public_path__ + "img/arrow-right-acumulate-periodo.cbe46dcc.svg";